export default {
    scheduled_actions_tab_entity_name: "Nombre de la entidad",
    scheduled_actions_tab_name: "Nombre",
    scheduled_actions_tab_action: "Acción",
    scheduled_actions_tab_scheduled_on: "Programado en",
    scheduled_actions_tab_executed: "Ejecutado",
    scheduled_actions_tab_created_on: "Creado en",
    scheduled_actions_tab_created_by: "Creado por",
    scheduled_actions_tab_updated_on: "Actualizado en",
    scheduled_actions_tab_edit: "Editar",
    scheduled_actions_tab_delete: "Eliminar",
    scheduled_actions_tab_edit_is_executed: "Las acciones programadas que ya se han ejecutado no se pueden editar",
    scheduled_actions_tab_delete_is_executed: "Las acciones programadas que ya se han ejecutado no se pueden borrar",
    scheduled_actions_tab_updated_by: "Actualizado por",
    scheduled_actions_error: "Error",
};
